// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import permissions from '@src/views/apps/roles-permissions/store'

const rootReducer = {
  auth,
  navbar,
  layout,
  permissions
}

export default rootReducer
